import { theme } from '@hhgtech/hhg-components'

export const getThrResult = (
  age: any,
  rate: any,
  chart: any,
  f: any,
  status: any,
) => {
  const isAdult =
    new Date().getTime() - new Date(age as string).getTime() >=
    18 * 365 * 24 * 60 * 60 * 1000
      ? true
      : false
  const adultResult = [
    {
      id: 4,
      value: 'Athlete',
      title: f({
        id: 'targetHeartRate.result.athlete',
        defaultMessage: 'Athlete',
      }),
      color: theme.colors.primary500,
      colorTitle: theme.colors.primary500,
    },
    {
      id: 3,
      value: 'Excellent',
      title: f({
        id: 'targetHeartRate.result.excellent',
        defaultMessage: 'Excellent',
      }),
      color: theme.colors.green800,
      colorTitle: theme.colors.green800,
    },
    {
      id: 2,
      value: 'Good',
      title: f({
        id: 'targetHeartRate.result.good',
        defaultMessage: 'Good',
      }),
      color: theme.colors.green500,
      colorTitle: theme.colors.green500,
    },
    {
      id: 1,
      value: 'Average',
      title: f({
        id: 'targetHeartRate.result.average',
        defaultMessage: 'Average',
      }),
      color: theme.colors.yellow600,
      colorTitle: theme.colors.yellow600,
    },
    {
      id: 0,
      value: 'Poor',
      title: f({
        id: 'targetHeartRate.result.poor',
        defaultMessage: 'Poor',
      }),
      color: theme.colors.red800,
      colorTitle: theme.colors.red800,
    },
  ]
  const childResult = [
    {
      id: 2,
      value: 'Abnormal',
      title: f({
        id: 'targetHeartRate.result.abnormal',
        defaultMessage: 'Abnormal',
      }),
      color: theme.colors.neutral50,
      colorTitle: theme.colors.gray500,
    },
    {
      id: 1,
      value: 'Normal',
      title: f({
        id: 'targetHeartRate.result.normal',
        defaultMessage: 'Normal',
      }),
      color: theme.colors.green500,
      colorTitle: theme.colors.green500,
    },
    {
      id: 0,
      value: 'Abnormal',
      title: f({
        id: 'targetHeartRate.result.abnormal',
        defaultMessage: 'Abnormal',
      }),
      color: theme.colors.neutral50,
      colorTitle: theme.colors.gray500,
    },
  ]
  const resultType = isAdult ? adultResult : childResult

  const resultChart = resultType.map((x, idx) => ({
    id: x.id,
    value: x.value,
    title: x.title,
    color: x.color,
    colorTitle: x.colorTitle,
    markupMin: chart[idx]?.markup,
    markupMax: chart[idx + 1]?.markup - 1 || 200,
  }))

  const result =
    resultChart.find(
      (c) =>
        c.value === status &&
        parseFloat(rate) >= c.markupMin &&
        parseFloat(rate) <= c.markupMax,
    ) || resultChart[0]
  return {
    result,
    resultType,
    resultChart,
  }
}
